export default "__VITE_ASSET__C$yry$qc__"